export default __webpack_public_path__ + "static/media/product-12.900a46aa.jpg";